import styled from "styled-components";

export const Span = styled.span`
  line-height: 2;
  font-size: ${({ theme }) => theme.fontSize};
  font-family: ${({ theme }) => theme.fontFamily};
`;
